const PROGRESS_BY_STATUS = {
  pending: { label: 'Pending', completed: 1, current: null, tone: 'neutral' },
  reviewing: { label: 'Under review', completed: 1, current: 1, tone: 'review' },
  interviewing: {
    label: 'Interview stage', completed: 1, current: 1, tone: 'review',
    message: 'Your application is at the interview stage. You will be contacted shortly.'
  },
  accepted: {
    label: 'Accepted', completed: 3, current: null, tone: 'positive',
    message: 'Your application has been accepted. We would like to move forward with your application.'
  },
  rejected: {
    label: 'Not selected', completed: 3, current: null, tone: 'negative',
    message: 'Your application was not selected. Thank you for your interest in Veloura.'
  },
  archived: {
    label: 'Archived', completed: 1, current: null, tone: 'inactive',
    message: 'This application is archived. Its previous review stage or decision is not available.'
  }
};

export const APPLICATION_STAGES = [
  { title: 'Submitted', description: 'Your application is with us' },
  { title: 'Under review', description: 'Our team reviews your details' },
  { title: 'Decision', description: 'Check your status for updates' }
];

export const getApplicationProgress = status => Object.prototype.hasOwnProperty.call(PROGRESS_BY_STATUS, status) ? PROGRESS_BY_STATUS[status] : {
  label: 'Status unavailable', completed: 0, current: null, tone: 'unknown',
  message: 'We could not identify the current application stage. Please check again later.'
};
